export const colours = {
  beige: '#deb887',
  black: '#2C3E50',
  blue: '#1CA8DD',
  blueDark: '#1A79B3',
  butterscotch: '#FA0',
  fuschia: '#F0D',
  green: '#1BC98E',
  green2: '#27AE60',
  grey: '#434857',
  grey2: '#606060',
  maroon: '#FAA',
  red: '#E64759',
  orange: '#E68018',
  peach: '#C0392B',
  purple: '#9F86FF',
  yellow: '#E4D836',
};

export const METRICS_CHARTS = {
  CCF_DEFAULT: colours.blue,
  NCF_DEFAULT: colours.grey2,
  CCF_SECONDARY: colours.blueDark,
  NCF_SECONDARY: colours.grey,
  RED: colours.red,
  YELLOW: colours.yellow,
  HIGHLIGHT_1: colours.maroon,
  HIGHLIGHT_2: colours.butterscotch,
  GIVEN_JOB_HIGHLIGHT: colours.fuschia
};

export const getFadingColour = (fades) => percent => {
  const points = Object.keys(fades).sort();

  if (points.length === 0) {
    return '#000';
  }

  // Handle the base case so we can start the loop at 1.
  if (percent <= points[0]) {
    return fades[points[0]];
  }

  // Cap to the max if possible
  if (percent === points[points.length - 1]) {
    return fades[points[points.length - 1]];
  }

  for (let i = 1; i < points.length; i++) {
    if (percent > points[i - 1] && percent <= points[i]) {
      return colourFade(
        percent,
        points[i - 1],
        points[i],
        fades[points[i - 1]],
        fades[points[i]]
      );
    }
  }

  // This shouldn't happen.
  return '#000';
};

export const colourFade = (value, min, max, minColour, maxColour) => {
  const startColour = colourToObj(minColour);
  const endColour = colourToObj(maxColour);

  const rDelta = endColour.r - startColour.r;
  const gDelta = endColour.g - startColour.g;
  const bDelta = endColour.b - startColour.b;

  const percent = (value - min) / (max - min);

  const fade = {
    r: Math.round(rDelta * percent + startColour.r),
    g: Math.round(gDelta * percent + startColour.g),
    b: Math.round(bDelta * percent + startColour.b)
  };

  return objToColour(fade);
};

export const objToColour = colourObj => {
  let r = colourObj.r.toString(16);
  r = r.length === 1 ? '0' + r : r;

  let g = colourObj.g.toString(16);
  g = g.length === 1 ? '0' + g : g;

  let b = colourObj.b.toString(16);
  b = b.length === 1 ? '0' + b : b;

  return '#' + r + g + b;
};

export const colourToObj = colour => {
  if (colour.length === 4) {
    return {
      r: parseInt(colour[1] + colour[1], 16),
      g: parseInt(colour[2] + colour[2], 16),
      b: parseInt(colour[3] + colour[3], 16)
    };
  } else if (colour.length === 7) {
    return {
      r: parseInt(colour.substr(1, 2), 16),
      g: parseInt(colour.substr(3, 2), 16),
      b: parseInt(colour.substr(5, 2), 16)
    };
  }

  return {
    r: 0,
    g: 0,
    b: 0
  };
};

export const COLOUR_FADE = {
  0.25: '#C00',
  0.5: '#FA0',
  0.75: '#DD0',
  0.875: '#5C5',
  1: '#2A9fd6'
};



// WEBPACK FOOTER //
// src/helpers/colours.js